import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import App from './App.vue'
import router from './router'
import store from "./store";
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import BootstrapVue from 'bootstrap-vue'
import { initializeFirebase } from './push-notification';

Vue.use(BootstrapVue)

import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

import VueNumeric from 'vue-numeric'

Vue.use(VueNumeric)
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(Datetime)
Vue.use(VueSweetalert2);

import VeeValidate, { Validator } from 'vee-validate';
import es_ES from "vee-validate/dist/locale/es.js";

Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
  validity: true
});
Validator.localize("es_ES", es_ES);

import VueNumberInput from '@chenfengyuan/vue-number-input';
Vue.use(VueNumberInput);

// import VueLuxon from 'vue-luxon';
// Vue.use(VueLuxon);

Vue.config.productionTip = false

Vue.use(ArgonDashboard)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

initializeFirebase();
